import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FileFilledSvg from "@ant-design/icons-svg/es/asn/FileFilled";
import AntdIcon from "../components/AntdIcon";
var FileFilled = function FileFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FileFilled.displayName = 'FileFilled';
}
export default /*#__PURE__*/React.forwardRef(FileFilled);